import React from 'react';

//Hooks
import {useRef, useEffect, useState} from 'react';

//Components
import InstagramEmbed from 'react-instagram-embed';

//Hooks
import {useSelector} from "react-redux";

const WebVideo = ({url, className}) => {
    const tintColor = useSelector(state => state.companies.tintColor);
    const ref = useRef(null)
    const [height, setHeight] = useState(0)

    const handleResize = /* istanbul ignore next */ () => {
        setHeight(ref.current.clientWidth)
    };

    useEffect(() /* istanbul ignore next */ => {
        if (!ref.current) {
            return
        }
        setHeight(ref.current.clientWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [ref]);

    let uri = url;
    let type;

    let match = url.match(/http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/(watch\?v=|shorts\/)|\.be\/)([\w\-_]*)(&(amp;)?‌​[\w?‌​=]*)?/);
    if (match && match.length >= 5) {
        uri = `https://www.youtube.com/embed/${match[2]}`;
        type = 'yt'
    }

    match = url.match(/http(?:s?):\/\/(?:www\.)?instagram\.com(\/p\/)(\w+\/?)/);
    if (match && match.length >= 3) {
        uri = match[0];
        type = 'insta'
    }

    match = url.match(/^(https?:\/\/www\.facebook\.com\/)(?:video\.php\?v=|.*?\/videos\/|watch\/\?v=)(\d+)\/?$/);
    if (match && match.length >= 3) {
        uri = `https://www.facebook.com/video/embed?video_id=${match[2]}`;
        type = 'fb'
    }

    match = url.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i);
    if (match && match.length >= 1) {
        uri = `https://player.vimeo.com/video/${match[1]}?color=${tintColor.replace('#', '')}title=0&byline=0&portrait=0`;
        type = 'vimeo'
    }

    return (
        type === 'insta' ? (
            <InstagramEmbed
                url={uri}
                maxWidth={740}
                hideCaption={true}
                containerTagName='div'
                protocol='https:'
                injectScript
            />
        ) : (
            <iframe
                ref={ref}
                title={url}
                style={{height: `${height * 0.5625}px`}}
                src={uri}
                className={className}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        )
    );
};

export default WebVideo